import React from "react";

import noSearchResults from "../../illustrations/undraw_empty_xct9.svg";

import Typography from "@material-ui/core/Typography";

export default function SearchResultsNotFound() {
  return (
    <React.Fragment>
      <div style={{ display: "flex", marginTop: 16, marginBottom: 12 }}>
        <img
          src={noSearchResults}
          alt={"Search Results Not Found"}
          style={{
            width: "40%",
            margin: "auto",
          }}
        ></img>
      </div>
      <Typography align="center" variant="h5" component="h5">
        No Results Found! Try Refining your search.
      </Typography>
    </React.Fragment>
  );
}
